import { Navigate, createBrowserRouter, useParams } from 'react-router-dom';

import { RouteWrapper } from '@components/Navigation/RouteWrapper';
import { lazy } from 'react';
import MoyasarTest from '@/pages/MoyasarTest';

const Home = lazy(() => import('../pages/Home'));
const Search = lazy(() => import('../pages/Search'));
const Favourites = lazy(() => import('../pages/Favourites'));
const Offers = lazy(() => import('../pages/Offers'));
const Rating = lazy(() => import('../pages/Rating'));
const Sell = lazy(() => import('../pages/Sell'));
const About = lazy(() => import('../pages/About'));
const Terms = lazy(() => import('../pages/Terms'));
const Privacy = lazy(() => import('../pages/Privacy'));
const Faq = lazy(() => import('../pages/Faq'));
const Contact = lazy(() => import('../pages/Contact'));
const Booking = lazy(() => import('../pages/Booking'));
const Listing = lazy(() => import('../pages/Listing'));
const OtpLogin = lazy(() => import('../pages/LoginWithOtp'));
const Signup = lazy(() => import('../pages/Signup'));
const ForgotPassword = lazy(() => import('../pages/ForgotPassword'));
const NotFound = lazy(() => import('../pages/NotFound'));
const SentryTestComponent = lazy(() => import('../pages/SentryTest'));
const ListingRedirect = lazy(() => import('../pages/ListingRedirect'));
const PaymentRedirect = lazy(() => import('../pages/PaymentRedirect'));

export const router = createBrowserRouter([
  {
    path: "/:lang?",
    element: <RouteWrapper />, // RouteWrapper will handle language dynamically
    children: [
      {
        path: "", // Home page
        element: <Home />,
      },
      {
        path: "cars", // `/cars` or `/en/cars`
        children: [
          {
            path: "", // `/cars` or `/en/cars`
            element: <Home />,
          },
          {
            path: ":conditionOrMake", // `/cars/:make` or `/en/cars/:make`
            element: <Home />,
          },
          {
            path: ":make/:model", // `/cars/:make/:model` or `/en/cars/:make/:model`
            element: <Home />,
          },
          {
            path: ":make/:model/:year", // `/cars/:make/:model/:year` or `/en/cars/:make/:model/:year`
            element: <Home />,
          },
          {
            path: ":make/:model/:year/:id", // `/cars/:make/:model/:year/:id` or `/en/cars/:make/:model/:year/:id`
            element: <Listing />, // Listing page
          },
        ],
      },
      {
        path: "search", // `/search` or `/en/search`
        element: <Search />,
      },
      {
        path: "favourites", // `/favourites` or `/en/favourites`
        element: <Favourites />,
      },
      {
        path: "offers", // `/offers` or `/en/offers`
        element: <Offers />,
      },
      {
        path: "rating", // `/rating` or `/en/rating`
        element: <Rating />,
      },
      {
        path: "sell", // `/sell` or `/en/sell`
        element: <Sell />,
      },
      {
        path: "about", // `/about` or `/en/about`
        element: <About />,
      },
      {
        path: "terms", // `/terms` or `/en/terms`
        element: <Terms />,
      },
      {
        path: "privacy", // `/privacy` or `/en/privacy`
        element: <Privacy />,
      },
      {
        path: "faq", // `/faq` or `/en/faq`
        element: <Faq />,
      },
      {
        path: "contact", // `/contact` or `/en/contact`
        element: <Contact />,
      },
      {
        path: "booking",
        children: [
          {
            path: ":id/:paymentType", // `/booking/:id/:paymentType` or `/en/booking/:id/:paymentType`
            element: <Booking />,
          },
          {
            path: ":id", // `/booking/:id` or `/en/booking/:id`
            element: <Booking />,
          },
        ],
      },
      {
        path: "moyasar-payment-redirect",
        element: <PaymentRedirect />,
      },
      {
        path: "login", // `/login` or `/en/login`
        element: <OtpLogin />,
      },
      {
        path: "signup", // `/signup` or `/en/signup`
        element: <Signup />,
      },
      {
        path: "otp-login", // `/otp-login` or `/en/otp-login`
        element: <OtpLogin />,
      },
      {
        path: "forgot-password", // `/forgot-password` or `/en/forgot-password`
        element: <ForgotPassword />,
      },
      {
        path: "*", // Catch-all for 404
        element: <NotFound />,
      },
      {
        path: "sentry-test", // `/sentry-test` or `/en/sentry-test`
        element: <SentryTestComponent />,
      },
      // {
      //   path:'test-moyasar-pay',
      //   element: <MoyasarTest />,
      // }
    ],
  },
  {
    path: '/listing/:id/detail',
    element: <ListingRedirect />,
  },
  {
    path: '/listing/:id',
    element: <ListingRedirect />,
  },
  {
    path: '/car/:id',
    element: <ListingRedirect />,
  },
]);
